/**
 * Pincode delivery estimate: six digits in, a delivery window out.
 *
 * The zone table comes from the block (data-zones): one line per zone,
 * comma-separated prefixes, a pipe, the promise. The longest matching
 * prefix wins, so "56" (Bengaluru) can sit beside "5" (the rest of the
 * south). The last valid pincode is remembered in localStorage and
 * answered on the next product page without being asked again.
 *
 * Once it has an answer the block collapses to that answer: one line,
 * "Arrives by Tue, 6 Oct to 131001 · Change", with the input and the
 * "order by 12 PM" note tucked away. They were an open form and a second
 * sentence sitting on every product page for a question the shopper had
 * already answered; Change brings the input back.
 */
(function () {
  if (customElements.get('pincode-estimate')) return;
  var KEY = 'glide:pincode';

  class PincodeEstimate extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-pincode-input]');
      this.button = this.querySelector('[data-pincode-check]');
      this.result = this.querySelector('[data-pincode-result]');
      if (!this.input || !this.result) return;
      this.zones = (this.dataset.zones || '').split('\n').map(function (line) {
        var bits = line.split('|');
        if (bits.length < 2) return null;
        return { prefixes: bits[0].split(',').map(function (s) { return s.trim(); }).filter(Boolean), promise: bits[1].trim() };
      }).filter(Boolean);
      var self = this;
      if (this.button) this.button.addEventListener('click', function () { self.check(); });
      this.input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); self.check(); } });
      this.input.addEventListener('input', function () {
        self.input.value = self.input.value.replace(/\D/g, '').slice(0, 6);
        if (self.input.value.length === 6) self.check();
      });
      try {
        var saved = localStorage.getItem(KEY);
        if (saved && /^\d{6}$/.test(saved)) { this.input.value = saved; this.check(true); }
      } catch (e) { /* storage unavailable */ }
    }

    sentence(pin, promise) {
      var m = /(\d+)\s*(?:-|to|–)\s*(\d+)|(\d+)/.exec(promise);
      if (!m || !/day/i.test(promise)) return 'Delivery to ' + pin + ': ' + promise;
      var days = parseInt(m[2] || m[3], 10);
      if (!days) return 'Delivery to ' + pin + ': ' + promise;
      var d = new Date();
      /* Orders ship within 24-48 business hours, so the estimate counts up
         to that many working days of dispatch before the courier's transit
         days (data-dispatch-days). The old 12 PM same-day cut-off is only a
         fallback for markup that does not pass it. */
      var dispatch = parseInt(this.dataset.dispatchDays, 10);
      if (isNaN(dispatch)) {
        dispatch = 0;
        var cutoff = parseInt(this.dataset.cutoff, 10);
        if (!isNaN(cutoff) && d.getHours() >= cutoff) d.setDate(d.getDate() + 1);
      }
      days += dispatch;
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0) added++;
      }
      var label = d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
      return 'Arrives by ' + label + ' to ' + pin;
    }

    check(silent) {
      var pin = (this.input.value || '').trim();
      if (!/^\d{6}$/.test(pin)) {
        if (!silent) this.result.textContent = this.result.dataset.invalid || 'Enter a 6-digit pincode';
        return;
      }
      var best = null, bestLen = 0;
      this.zones.forEach(function (zone) {
        zone.prefixes.forEach(function (prefix) {
          if (pin.indexOf(prefix) === 0 && prefix.length > bestLen) { best = zone; bestLen = prefix.length; }
        });
      });
      var promise = best ? best.promise : (this.dataset.fallback || '');
      if (promise) this.settle(this.sentence(pin, promise));
      else this.result.textContent = '';
      try { localStorage.setItem(KEY, pin); } catch (e) { /* ignore */ }
    }

    settle(text) {
      var self = this;
      this.result.textContent = text + ' ';
      var change = document.createElement('button');
      change.type = 'button';
      change.className = 'pincode__change';
      change.textContent = this.dataset.changeLabel || 'Change';
      change.addEventListener('click', function () { self.unsettle(); });
      this.result.appendChild(document.createTextNode('· '));
      this.result.appendChild(change);
      this.classList.add('is-settled');
      var block = this.closest('.delivery-estimate');
      if (block) block.classList.add('has-answer');
    }

    unsettle() {
      this.classList.remove('is-settled');
      var block = this.closest('.delivery-estimate');
      if (block) block.classList.remove('has-answer');
      this.result.textContent = '';
      this.input.focus();
      this.input.select();
    }
  }

  customElements.define('pincode-estimate', PincodeEstimate);
})();

